import Link from 'next/link';
import { AnchorHTMLAttributes, MouseEventHandler } from 'react';

import type { CatalogTheme } from '@/fo/util/theme';

import { styles } from './PaginationButton.styles';

interface PaginationButtonProps
  extends AnchorHTMLAttributes<HTMLAnchorElement> {
  selected?: boolean;
  href: string;
  disabled?: boolean;
  disabledNavigation?: boolean;
  theme?: CatalogTheme;
}

export function PaginationButton({
  children,
  selected,
  disabled,
  href,
  disabledNavigation,
  theme = 'default',
  onClick,
  ...props
}: PaginationButtonProps) {
  const slots = styles({ selected, disabled, theme });

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (disabledNavigation) {
      event.preventDefault();
    }

    onClick?.(event);
  };

  return (
    <Link
      className={slots.base()}
      href={href}
      onClick={handleClick}
      {...props}
    >
      {children}
    </Link>
  );
}
